<template>
    <div class="dashboard">
        <div class="content">
            <el-row class="mb10">
                <el-col :span="1" class="text-center bold">
                    Дата:
                </el-col>
                <el-col :span="4">
                    <el-date-picker
                        v-model="daysRange"
                        type="daterange"
                        range-separator="по"
                        start-placeholder="дата"
                        end-placeholder="дата"
                        clearable
                        format="dd.MM.yyyy"
                        value-format="dd.MM.yyyy"
                        :picker-options="pickerOptions"
                        size="mini"
                        class="w100"
                        @change="getRating"
                    />
                </el-col>
                <el-col :span="3" class="text-center bold">
                    Показывать уволенных
                </el-col>
                <el-checkbox v-model="showFired" @change="getRating" />
            </el-row>
            <el-row v-loading="loading">
                <el-col>
                    <div class="table measurers">
                        <div class="table-header">
                            <div class="table-row">
                                <div class="table-cell bold">
                                    <el-tooltip popper-class="table-header-hint" content="Рейтинг" effect="light" placement="top">
                                        <span>Рейтинг</span>
                                    </el-tooltip>
                                </div>
                                <div
                                    v-for="column in columns"
                                    :key="column.field + 'header'"
                                    class="table-cell bold"
                                >
                                    <el-tooltip popper-class="table-header-hint" :content="column.hint" effect="light" placement="top">
                                        <span>{{ column.title }}</span>
                                    </el-tooltip>
                                </div>
                            </div>
                        </div>
                        <div class="table-body">
                            <div v-for="(measurer, index) in measurersData" :key="index" class="table-row" :class="['table-row', isFiredEmployerClass(measurer.date_fired)]">
                                <div class="table-cell rating">
                                    {{ index + 1 }}
                                </div>
                                <div
                                    v-for="column in columns"
                                    :key="column.field + 'data'"
                                    :class="[column.cellClass, getShadowClass(measurer, column.field)]"
                                    :style="getCellOuterStyle(measurer, column.field, index + 1, measurersData.length)"
                                >
                                    <template v-if="column.hasAction">
                                        <span
                                            :class="{ 'link' : measurer[column.field] }"
                                            @click="openGrid(column.gridType, measurer[column.fieldIds])"
                                        >
                                            {{ measurer[column.field] }}
                                        </span>
                                    </template>
                                    <div v-else-if="column.field === 'profiles'">
                                        <el-tooltip popper-class="profile-hint" effect="light" placement="bottom">
                                            <div slot="content">
                                                <div
                                                    v-for="profile in measurer[column.field].filter(item => item.proportion !== 0)"
                                                    :key="profile.id"
                                                >
                                                    <div class="profile-proportion">
                                                        {{ profile.proportion }}%
                                                    </div>{{ profile.name }}
                                                </div>
                                            </div>
                                            <div class="profile-icon-orange"></div>
                                        </el-tooltip>
                                    </div>
                                    <div
                                        :style="getCellInnerStyle(measurer, column.field, index + 1, measurersData.length)"
                                        v-else
                                    >
                                        {{ measurer[column.field] }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="table-row-empty"></div>
                        <div class="table-footer">
                            <div class="table-row">
                                <div class="table-cell relative hide-border">
                                    <div class="table-label-total">
                                        ИТОГО:
                                    </div>
                                </div>
                                <div
                                    v-for="column in columns"
                                    :key="column.field + 'total'"
                                    :class="[
                                        'table-cell',
                                        {'substrate': column.field === 'efficiency'}
                                    ]"
                                    :style="getTotalCellOuterStyle(totalData, column.field)"
                                >
                                    <div
                                        :style="getTotalCellInnerStyle(totalData, column.field)"
                                        v-if="column.field !== 'profiles'"
                                    >
                                        {{ totalData[column.field] }}
                                    </div>
                                    <div v-else>
                                        <el-tooltip popper-class="profile-hint" effect="light" placement="bottom">
                                            <div slot="content">
                                                <div
                                                    v-for="profile in getProfileData(totalData[column.field])"
                                                    :key="profile.id"
                                                >
                                                    <div class="profile-proportion">
                                                        {{ profile.proportion }}%
                                                    </div>{{ profile.name }}
                                                </div>
                                            </div>
                                            <div class="profile-icon-white"></div>
                                        </el-tooltip>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import employersRating from '@/mixins/employersRating';

export default {
    name: 'MeasurersRating',
    mixins: [
        employersRating
    ],
    data() {
        return {
            showFired: 0,
            columns: [
                {
                    field: 'measurer',
                    title: 'Замерщик',
                    hint: 'Замерщик',
                    cellClass: 'table-cell text-left',
                    hasAction: false
                },
                {
                    field: 'sales',
                    title: 'Сумма продаж',
                    hint: 'Бюджет договора, заключенного в период минус договора в статусе "Договор фиксация"',
                    cellClass: 'table-cell substrate',
                    hasAction: false
                },
                {
                    field: 'measurementsCount',
                    title: 'Кол-во замеров',
                    hint: 'кол-во сделок с датой замера в период без ОДЗ Техотказов',
                    cellClass: 'table-cell',
                    hasAction: true,
                    fieldIds: 'measurementsIds',
                    gridType: 'deals'
                },
                {
                    field: 'refusesBeforeMeteringCount',
                    title: 'Кол-во ОДЗ',
                    hint: 'кол-во сделок с датой замера в период и галкой ОДЗ',
                    cellClass: 'table-cell',
                    hasAction: true,
                    fieldIds: 'refusesBeforeMeteringIds',
                    gridType: 'deals'
                },
                {
                    field: 'techRefusesCount',
                    title: 'Кол-во техотказов',
                    hint: 'кол-во сделок с датой замера в период и галкой Техотказ',
                    cellClass: 'table-cell',
                    hasAction: true,
                    fieldIds: 'techRefusesIds',
                    gridType: 'deals'
                },
                {
                    field: 'reMeasurementsCount',
                    title: 'Кол-во перезамеров',
                    hint: 'кол-во сделок с датой перезамера в период и галкой перезамер',
                    cellClass: 'table-cell',
                    hasAction: true,
                    fieldIds: 'reMeasurementsIds',
                    gridType: 'deals'
                },
                {
                    field: 'contractsCount',
                    title: 'Кол-во договоров',
                    hint: 'кол-во сделок с датой договора в период минус "Договор фиксация"',
                    cellClass: 'table-cell',
                    hasAction: true,
                    fieldIds: 'contractsIds',
                    gridType: 'deals'
                },
                {
                    field: 'efficiency',
                    title: 'Эффективность %',
                    hint: 'кол-во договоров/кол-во замеров',
                    cellClass: 'table-cell substrate',
                    hasAction: false
                },
                {
                    field: 'square',
                    title: 'м2',
                    hint: 'сделки с датой договора в период - сумма "Квадратура"',
                    cellClass: 'table-cell',
                    hasAction: false
                },
                {
                    field: 'squarePrice',
                    title: 'Цена м2',
                    hint: 'Сумма продаж/м2',
                    cellClass: 'table-cell',
                    hasAction: false
                },
                {
                    field: 'discountPercent',
                    title: 'Скидка %',
                    hint: 'сумма всех скидок(скидки в процентах) В РУБЛЯХ по сделкам с датой договора в период / сумма продаж',
                    cellClass: 'table-cell',
                    hasAction: false
                },
                {
                    field: 'profiles',
                    title: 'Доля профиля',
                    hint: 'название профиля - его доля в сделках',
                    cellClass: 'table-cell',
                    hasAction: false
                }
            ]
        };
    },
    computed: {
        measurersData() {
            return this.$store.state.analytics.measurers;
        },
        totalData() {
            return this.$store.state.analytics.measurersTotal;
        }
    },
    methods: {
        getProfileData(profiles) {
            return profiles && profiles.length ? profiles.filter(item => item.proportion !== 0) : [];
        },
        async getRating() {
            try {
                this.loading = true;
                await this.$store.dispatch('analytics/getMeasurersRating', {
                    startDay: this.daysRange[0],
                    endDay: this.daysRange[1],
                    showFired: +this.showFired
                });
            } catch (e) {
                console.log(e);
            } finally {
                this.loading = false;
            }
        }
    }
};
</script>
